import CommonApi from "../common/CommonApi";
import axios from "axios";
import SuccessResponse from "../dto/common/SuccessResponse";
import TopTenShopDto from "../dto/dashboard/TopTenShopDto";
import BookmarkedShopDto from "../dto/dashboard/BookmarkedShopDto";
import TopThreeSalesDto from "../dto/dashboard/TopThreeSalesDto";

class RealDashboardApi extends CommonApi {
    async getTopTenShops({ today }: { today: string }): Promise<SuccessResponse<TopTenShopDto[]>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/stores/top-ten-shops`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<TopTenShopDto[]>>(
            `${this.BASE_SERVICE_URL}/stores/top-ten-shops`,
            {
                headers: baseHeaders,
                params: { today },
            }
        );

        return response.data;
    }

    async getBookmarkedShops(): Promise<SuccessResponse<BookmarkedShopDto[]>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/dashboard/bookmarked-shops`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<BookmarkedShopDto[]>>(
            `${this.BASE_SERVICE_URL}/dashboard/bookmarked-shops`,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    async getTopThreeSales({ today }: { today: string }): Promise<SuccessResponse<TopThreeSalesDto[]>> {
        const baseHeaders = this.makeBaseHeader();

        await axios.options(`${this.BASE_SERVICE_URL}/stores/top-three-sales`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<TopThreeSalesDto[]>>(
            `${this.BASE_SERVICE_URL}/stores/top-three-sales`,
            {
                headers: baseHeaders,
                params: { today },
            }
        );

        return response.data;
    }
}

export default RealDashboardApi;
